import BillingAccount from 'logic/BillingAccount'
import React from 'react'
import { PracticeSearchForm, InvoiceSearchForm, CashBalanceTransactionSearchForm } from 'types/interfaces'

interface IAdminBillingAccountDetailContext {
  // data
  billingAccount?: BillingAccount
  
  // search forms
  practiceSearchForm: PracticeSearchForm
  invoiceSearchForm: InvoiceSearchForm
  cashBalanceTransactionSearchForm: CashBalanceTransactionSearchForm
  
  // search form update functions
  updatePracticeSearchForm: (name: string, value: any) => void
  updateInvoiceSearchForm: (name: string, value: any) => void
  updateCashBalanceTransactionSearchForm: (name: string, value: any) => void
  setPracticeSearchForm: (form: PracticeSearchForm) => void
  setInvoiceSearchForm: (form: InvoiceSearchForm) => void
  setCashBalanceTransactionSearchForm: (form: CashBalanceTransactionSearchForm) => void

  // fetch functions
  fetchBillingAccount: () => Promise<void>
}

const AdminBillingAccountDetailContext = React.createContext<IAdminBillingAccountDetailContext>({} as IAdminBillingAccountDetailContext)

export default AdminBillingAccountDetailContext